import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateWhatsappTemplateComponent } from "../../components/whatsapp-template/create-whatsapp-template/create-whatsapp-template.component";
import { WhatsappTemplateService } from 'src/app/private/services/whatsapp-template.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { PreviewWhatsappTemplateComponent } from "../../components/whatsapp-template/preview-whatsapp-template/preview-whatsapp-template.component";
import { MessageService } from 'primeng/api';
import { ContactGroupService } from 'src/app/private/services/contact-group.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-whatsapp-template',
  imports: [ToolBarComponent,
    SharedModule, CreateWhatsappTemplateComponent, PreviewWhatsappTemplateComponent],
  templateUrl: './whatsapp-template.component.html',
  styleUrl: './whatsapp-template.component.scss'
})
export class WhatsappTemplateComponent {
  isAddTemplate: boolean = false;
  isEditTemplate: boolean = false;
  isOpenRejectionReason: boolean = false;
  isPreview: boolean = false;
  isDeleteTemplate: boolean = false;

  templateData: any[] = [];
  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  loading: boolean = false;
  selectedTemplates: any[] = [];

  displayedColumns: any[] = [];
  templateToEdit: any = {};
  mappingDataToEdit: any = {};
  storeVaraiableMappingOnId: any = {};

  isLoading = false;

  templateActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Template',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditTemplate = true;
          }
        },
        {
          label: 'Preview Template',
          icon: 'pi pi-fw pi-eye',
          command: () => {
            this.isPreview = true;
          }
        },
        {
          label: 'Delete Template',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteTemplate = true;
          }
        }
      ]
    }
  ]

  templateActionItems2: any[] = [
    {
      label: 'Options',
      items: [

        {
          label: 'Preview Template',
          icon: 'pi pi-fw pi-eye',
          command: () => {
            this.isPreview = true;
          }
        },
        {
          label: 'Rejection Reason',
          icon: 'pi pi-times-circle',
          command: () => {
            this.isOpenRejectionReason = true;
          }
        },
        {
          label: 'Delete Template',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteTemplate = true;
          }
        }
      ]
    }
  ]

  contactGroupColumns: any[] = [];
  showWhatsappConfigAlert: boolean = false;

  constructor(
    private api: WhatsappTemplateService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private contactGroupService: ContactGroupService,
    private router: Router
  ) { }

  ngOnInit() {
    // Check if WhatsApp configuration exists
    const isWhatsappExist = this.localStorage.getIsWhatsappExist();
    
    if (!isWhatsappExist) {
      this.showWhatsappConfigAlert = true;
    }

    this.setDisplayColumns();
    this.getAllContactGroupColumns();
  }

  navigateToWhatsappConfig() {
    this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 2 } });
  }

  setDisplayColumns() {
    this.displayedColumns.push({ field: 'template_name', header: 'Template Name', type: 'template_name' });
    this.displayedColumns.push({ field: 'status', header: 'Status', type: 'status' });
    this.displayedColumns.push({ field: 'action', header: 'Actions', type: 'actions' });
  }

  getAllContactGroupColumns() {
    const payload = {
      organization_id: this.localStorage.getOrganizationId()
    };

    this.contactGroupService.getAllContactGroupListColumns(payload).subscribe({
      next: (response: any) => {
        if (response) {
          this.contactGroupColumns = response;
        }
      },
      error: (error: any) => {
        console.error('Error fetching contact group columns:', error);
      }
    });
  }

  loadData(event: any,) {
    // const body = {
    //   organization_id: this.localStorage.getOrganizationId(),
    //   pageNo: page + 1,
    //   pageSize: size,
    // };

    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;


    const body = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId()
      },
      "page": page,
      "limit": size,
      "order": {
        "col": "\"template\".\"updatedAt\"",
        "dir": "DESC"
      }
    }



    this.loading = true;
    this.api.getAllGupshupTemplates(body).subscribe({
      next: (data) => {
        this.templateData = data.rows
        this.totalRecords = data.count;
        this.storeVaraiableMappingOnId = this.templateData.map((template: any) => {
          return {
            id: template?.template_data?.id,
            variable_mapping: template.variable_mapping || {}
          }
        });
        this.templateData = this.templateData.map((template: any) => {
          return template?.template_data
        }
        );
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  reloadTable() {
    this.loadData({ first: 0, rows: this.rows });
  }

  setTemplateEditData(template: any) {
    console.log("template", template);
    this.mappingDataToEdit = this.storeVaraiableMappingOnId.find((item: any) => item.id === template.id)?.variable_mapping || {};

    console.log("this.mappingDataToEdit", this.mappingDataToEdit);
    this.templateToEdit = template;
  }

  formatMessage2(message: string): string {
    message = message.split('|')[0].trim();
    return message
      .replace(/\n/g, '') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>') // Replace *text* with <b>text</b>
      .replace(/<div>/g, '<span>') // Replace <div> with <p>
      .replace(/<\/div>/g, '</span>'); // Replace </div> with </p>
}

  refreshStatus() {
    const body = {
      "organization_id": this.localStorage.getOrganizationId(),
    }
    this.loading = true;
    this.api.refreshGupshupTemplates(body).subscribe({
      next: () => {
        this.reloadTable();
      },
      error: () => {
      }
    });
  }


  handleDelete() {

    this.isLoading = true;
    const payload = {
      organization_id : this.localStorage.getOrganizationId(),
      elementName: this.templateToEdit.elementName,
      template_id: this.templateToEdit.id
    }

    this.api.deleteTemplate(payload).subscribe(
      (response: any) => {
        if (response) {
          this.reloadTable();
          this.isLoading = false;
          this.isDeleteTemplate = false;
        }
      },
      (error: any) => {
        // this.toast.error("Error occurred while deleting template");
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting template' });
      }
    );

  }
}
